/**
 * Hero Slider
 * 
 * 
 */
import gsap from 'gsap';
import Splitting from 'splitting';

export default class HeroSlider {
    private hero: HTMLElement;
    private slides: NodeListOf<Element>;
    private loop: number;
    private bullets: Array<Element>;
    private currentSlide: number = 0;

    constructor(hero: HTMLElement) {
        if (!hero) return;
        this.hero = hero;
        this.slides = this.hero.querySelectorAll('.hero-slide');
        if (this.slides && this.slides.length > 1 ) {
            this.setupNav();
            this.slideTo(0);
        }
    }

    setupNav() {
        const numberOfSlides = this.slides.length;
        const nav = document.createElement('div');
        nav.classList.add('hero-slide-nav');
        const bullets = [];
        for (let i = 0; i < numberOfSlides; i++) {
            bullets[i] = document.createElement('span');
            bullets[i].innerText = (i + 1).toString();
            if (i === 0) bullets[i].classList.add('hero-slide-bullet-active');
            bullets[i].addEventListener('click', () => {
                this.slideTo(i);
            });
            this.bullets = bullets;
            nav.appendChild(bullets[i]);
        }
        this.hero.appendChild(nav);
    }

    slideTo(slideIndex) {
        window.clearInterval(this.loop);
        const currentSlide = this.hero.querySelector('.hero-slide-active');
        currentSlide.classList.remove('hero-slide-active');
        const currentBullet = this.hero.querySelector('.hero-slide-bullet-active');
        currentBullet.classList.remove('hero-slide-bullet-active');
        this.bullets[slideIndex].classList.add('hero-slide-bullet-active');
        this.slides[slideIndex].classList.add('hero-slide-active');
        const tl = gsap.timeline();
        if (!this.slides[slideIndex].querySelector('.word')) {
            //  Hero caption
            const heroCaption = this.slides[slideIndex].querySelector('.hero-caption h2');
            const words = Splitting({ target: heroCaption, by: 'chars' });
            tl.from(words[0].chars, { delay: 1, duration: 5, opacity: 0, x: -10, y: 100, ease: "expo.out", stagger: 0.02 });
        } else {
            const chars = this.slides[slideIndex].querySelectorAll('.char');
            tl.from(chars, { delay: 1, duration: 5, opacity: 0, x: -10, y: 100, ease: "expo.out", stagger: 0.02 });
        }
        this.start();
    }

    start() {
        this.loop = window.setInterval(() => {
            this.currentSlide++;
            if (this.currentSlide >= this.slides.length) {
                this.currentSlide = 0;
            }
            this.slideTo(this.currentSlide);
        }, 10000);
    };
}